

import advocateReducer from './AdvocateReducer'
export { advocateReducer }

export * from './AdvocateActions'
export * from './AdvocateSelectors';



// WEBPACK FOOTER //
// ./src/store/advocate-dashboard/index.js